export default async (
  dataHijackerFunctions,
  interval = 0,
  timeout = 20000
) => {
  if (!document.querySelector('body.user-theme')) return;

  const is_page_a_scorm_player = document.querySelector(
    'body#page-mod-scorm-player'
  )
    ? true
    : false;

  if (!is_page_a_scorm_player) return;

  if (!document.querySelector('body#page-mod-scorm-player.format-topics'))
    return;

  const LOG = (...a) => {
    if (localStorage.getItem('treadmaster_scormdebug') === 'true') {
      console.log('[Treadmaster SCORM:hijack-data] ', ...a);
    }
  };

  const STORE_KEY = '__treadmaster_scorm_hijack_data';

  let iframe;
  let iframeContentWindow;
  let origGlobalProvideData;
  try {
    const result = await getGlobalProvideData(interval, timeout);
    iframe = result.iframe;
    iframeContentWindow = result.iframeContentWindow;
    origGlobalProvideData = result.origGlobalProvideData;
  } catch (e) {
    return;
  }

  iframeContentWindow[STORE_KEY] = {
    dataPayloadReceivedFirst: false
  };

  //Hacky fix for when scorm doesn't send the data payload when the module
  //is opened in a new tab and out of focus
  dataHijackerFunctions.unshift(firstDataPayloadChecker);

  hijackGlobalProvideData(
    iframeContentWindow,
    origGlobalProvideData,
    dataHijackerFunctions
  );

  //Hacky fix for when scorm doesn't send the data payload when the module
  //is opened in a new tab and out of focus.
  //Will reload the page every 2 seconds until the data payload is received
  noDataPayloadReloader();

  async function getGlobalProvideData(interval, timeout) {
    const started = Date.now();

    //Wait for the SCORM iframe and its globalProvideData function to be available
    while (Date.now() - started < timeout) {
      const iframe = document.querySelector('iframe#scorm_object');
      const iframeContentWindow = iframe?.contentWindow;

      LOG('Checking for globalProvideData');
      LOG(iframeContentWindow);
      LOG(iframeContentWindow?.globalProvideData);

      if (
        iframeContentWindow &&
        typeof iframeContentWindow?.globalProvideData === 'function'
      ) {
        return {
          iframe,
          iframeContentWindow,
          origGlobalProvideData: iframeContentWindow?.globalProvideData
        };
      }

      // Wait based on the specified interval before checking again
      await new Promise((resolve) => setTimeout(resolve, interval));
    }

    LOG('Timed out waiting for globalProvideData', timeout);
    throw new Error('Timed out waiting for globalProvideData');
  }

  function hijackGlobalProvideData(icw, orig, listenerFunctions = []) {
    icw.globalProvideData = function (type, jsonPayload) {
      const args = Array.from(arguments);
      let modifiedPayload = JSON.parse(jsonPayload);

      // Pass the payload through each listener function in sequence
      listenerFunctions.forEach((fn) => {
        try {
          modifiedPayload =
            fn({ type, payload: modifiedPayload, iframeContentWindow: icw }) ||
            modifiedPayload;
          LOG(`${type} payload modified`);
        } catch (e) {
          LOG('Error in listener function', e);
        }
      });

      // Update the arguments with the modified payload
      args[1] = JSON.stringify(modifiedPayload);

      LOG('Hijacked globalProvideData successfully');

      // Call the original globalProvideData with the modified arguments
      return orig.apply(this, args);
    };
  }

  function firstDataPayloadChecker(scormHijackParams) {
    const { type, payload, iframeContentWindow } = scormHijackParams;

    if (iframeContentWindow[STORE_KEY].dataPayloadReceivedFirst) return;

    if (
      !iframeContentWindow[STORE_KEY].dataPayloadReceivedFirst &&
      type === 'data'
    ) {
      iframeContentWindow[STORE_KEY].dataPayloadReceivedFirst = true;
      return;
    }
    // if (
    //   !iframeContentWindow[STORE_KEY].dataPayloadReceivedFirst &&
    //   type !== 'data'
    // ) {
    //   window.location.reload();
    // }
  }

  async function noDataPayloadReloader() {
    const started = Date.now();

    while (!iframeContentWindow[STORE_KEY].dataPayloadReceivedFirst) {
      await new Promise((resolve) => setTimeout(resolve, 5000));

      LOG(`document.hidden: ${document.hidden}`);

      if (
        !document.hidden &&
        !iframeContentWindow[STORE_KEY].dataPayloadReceivedFirst
      ) {
        LOG(`window.location.href: ${window.parent.location.href}`);

        window.location.reload();
        return;
      }

      LOG(
        `dataPayloadReceivedFirst: ${iframeContentWindow[STORE_KEY].dataPayloadReceivedFirst}`
      );
    }
  }
};
